"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONVENTIONAL_BASE = [
    "1WO",
    "ADH",
    "AMLT",
    "BCH",
    "BRC",
    "BTCV",
    "BTRN",
    "CAN",
    "CEL",
    "CHI",
    "CIM",
    "CMCT",
    "COT",
    "CRPT",
    "DACS",
    "DASH",
    "DENT",
    "DREAM",
    "DRG",
    "ECH",
    "ENJ",
    "ETN",
    "EWT",
    "FCT",
    "FDX",
    "FLEX",
    "FLIXX",
    "FSN",
    "FTX",
    "GAT",
    "GEN",
    "GET",
    "GOM2",
    "GZE",
    "HBAR",
    "HYDRO",
    "IDH",
    "IHF",
    "ILK",
    "IPSX",
    "IXT",
    "KMD",
    "KRL",
    "LCX",
    "LIKE",
    "LND",
    "LTC",
    "MGO",
    "MITH",
    "MITX",
    "MRK",
    "MTC",
    "NEO",
    "NII",
    "OAX",
    "OMG",
    "ONG",
    "ORBS",
    "PMA",
    "PPL",
    "QTUM",
    "RBTC",
    "RFOX",
    "RIF",
    "ROOBEE",
    "SER",
    "SGA",
    "SIX",
    "SNX",
    "STAC",
    "STACS",
    "STORJ",
    "THRT",
    "THX",
    "TPAY",
    "TPT",
    "TRX",
    "UBT",
    "VUU",
    "WIN",
    "WLO",
    "XEM",
    "XLM",
    "XMR",
    "XNK",
    "XRP",
    "ZEC",
    "ZPR",
    "QASH",
    "ETH",
    "BTC",
    // Stable coins last
    "ANCT",
    "DAI",
    "USDC",
    "USDT",
    "IDRT"
];
